module.exports = __webpack_public_path__ + "img/shangqi.b1f8fac5.png";